import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    gap: 1.875rem;
  }
`;

export const TemplateSuggestionsContainer = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  gap: 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex-flow: row;
    flex-wrap: wrap;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    gap: 1.875rem;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
  color: #030303;
  cursor: pointer;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("medium")} {
    width: calc(48%);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    width: calc(30%);
  }
`;

export const TemplateSuggestion = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

export const IllustrationContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.11) 0px 0px 20px 0px;
  
  &:after {
    display: flex;
    justify-content: center;
    align-items: center;
    content: "Preview";
    font-weight: bold;
    color: #FFFFFF;
    font-size: 1.5rem;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    transition: all 0.3s ease 0s;
  }

  &:hover:after {
    opacity: 1;
  }
`;

export const Illustration = Styled.img`
  width: 100%;
  height: 100%;
`;
